import axios from 'axios';
import { toastr } from 'react-redux-toastr';

import { getConfig, getUserToken } from '../util/helper';

export async function editarusr(login, email, telefone, imagem, idnva) {
    const cfg = await getConfig('corporate');
    const formData = new FormData();
    formData.append('login', login);
    formData.append('email', email);
    formData.append('phone', telefone);
    formData.append('image', imagem);
    formData.append('idnva', idnva);
    
    return await submitAXIOS(formData, `${cfg.baseUrl}/editarusr`, 'PUT');
}

async function submitAXIOS(values, url, type) {
    return async dispatch => {
        switch (type) {
            case 'POST':
                axios.post(url, values, {
                    headers: {
                        Authorization: `bearer ${getUserToken()}`
                    }
                })
                    .then(resp => {                        
                        dispatch([
                            { type: 'USER_UPDATED', payload: resp.data, sucesso: true }
                        ])
                    })
                    .catch(e => {
                        if (e.response) {
                            e.response.data.errors.forEach(
                                error => toastr.error('Atenção',  error))
                        }
                        else {
                            toastr.error('Erro ao salvar', 'Houve um erro a salvar o item, tente novamente.');
                        }
                    })

                break;
            case 'PUT':
                return axios.put(url, values, {
                    headers: {
                        Authorization: `bearer ${getUserToken()}`,
                        'content-type': 'multipart/form-data'
                    }
                })
                    .then(resp => {
                        dispatch([
                            { type: 'USER_UPDATED', payload: resp.data, sucesso: true }
                        ]);
                        toastr.success('Sucesso', 'Informações alteradas com sucesso.');
                        return resp.data;
                    })
                    .catch(e => {
                        if (e.response) {
                            e.response.data.errors.forEach(
                                error => toastr.error('Atenção', error))
                        }
                        else {
                            toastr.error('Erro ao salvar', 'Houve um erro a salvar o item, tente novamente.');
                        }
                        return e;
                    })
                break;
            default:
                break;
        }
    }
}

export async function reset() {
    return dispatch => {
        dispatch({ type: 'RESET' })
    }
}
